import React from 'react';
import LandingPage from 'views/landing';

const landingRoutes = { path: '/landing', element: <LandingPage /> };

export default landingRoutes;
